"use client";

import {
  apiRequest,
  S3MediaCreateURLDTO,
  FileInput,
  MediaUploadDTO,
  UTIL_ENDPOINTS,
  DataReturnType,
} from "@alba-cars/common-modules";

// Main function to get signed URLs
export const createS3Urls = async (data: S3MediaCreateURLDTO) => {
  const response = await apiRequest<DataReturnType<MediaUploadDTO[]>>(UTIL_ENDPOINTS.media.createS3Url, {
    method: "POST",
    body: JSON.stringify(data),
  });

  return response;
};

// Helper function for vehicle-specific uploads
export const createVehicleS3Urls = async (vehicleId: string, files: FileInput[]) => {
  const response = await createS3Urls({
    vehicleId,
    files,
  });

  return response.data;
};

// Helper function for folder-specific uploads
export const createFolderS3Urls = async (folder: string, files: FileInput[]) => {
  const response = await createS3Urls({
    folder,
    files,
  });

  return response.data;
};
